import { useBaseForm } from "../../components/fx";
import { useControlFormStore } from "../../controllers/ControlFormController";
import type { ReactElement } from 'react';

const Control = () => {
    const { renderForm } = useBaseForm({ storeHook: useControlFormStore });
    return (
        <>
            {renderForm()}
        </>
    );
}

export default Control;
